import React, { useState } from "react";
import { useSelector } from 'react-redux'
import { Button, Typography, Row, Col, Card, Input, Dropdown, Menu, Skeleton } from 'antd'
import { useHistory } from 'react-router-dom'
import {DownOutlined, SearchOutlined, WifiOutlined} from '@ant-design/icons';
import './esim.css'
import _ from 'lodash'
import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
const { Title, Text } = Typography;
const { Search } = Input;

const letterGroups = {
    "A-B": ["A", "B"],
    "C-F": ["C", "D", "E", "F"],
    "G-H": ["G", "H"],
    "I-L": ["I", "J", "K", "L"],
    "M-N": ["M", "N"],
    "O-Q": ["O", "P", "Q"],
    "R-T": ["R", "S", "T"],
    "U-Z": ["U", "V", "W", "X", "Y", "Z"],
};



const AllDestinationsPage = () => {
    const [selectedGroup, setSelectedGroup] = useState("A-B");
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedRegion, setSelectedRegion] = useState('');
    const history = useHistory();

    const handleSeePlans = (countryId, type = 'local') => {
        history.push(`/packages/${countryId}?type=${type}`);
    };
    const handleImageError = (e, countryName) => {
        e.target.style.display = 'none';
        e.target.parentElement.className += ' destination-image-fallback';
        e.target.parentElement.innerHTML = `<div class="destination-image-fallback-letter">${countryName.charAt(0)}</div>`;
    };

    const destinationsType1 = useSelector(
        (state) => state.esimReducer.destinationsType1 || []
    );
    const destinationsType2 = useSelector(state => state.esimReducer.destinationsType2 || []);

    let filteredDestinations = destinationsType1.filter((d) =>
        letterGroups[selectedGroup].includes(d.name.charAt(0).toUpperCase())
    );
    // Apply search filter
    if (searchTerm) {
        filteredDestinations = destinationsType1.filter((d) =>
            d.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }

    const handleRegionClick = ({ key }) => {
        const selectedRegion = destinationsType2.find(region =>
            region.country_id === key || region.name === key
        );
        if (selectedRegion) {
            setSelectedRegion(selectedRegion.name);
            const countryId = selectedRegion.country_id || key;
            handleSeePlans(countryId, 'region');
        }
    };

    const regionsMenu = (
        <Menu onClick={handleRegionClick}>
            {destinationsType2.map(region => (
                <Menu.Item key={region.country_id || region.name}>
                    {region.name}
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <div className="all-destinations-container">
            <div className="all-destinations-wrapper">
                {/* Header Section */}
                <div className="destinations-header">
                    <Title level={1} className="destinations-header-title">
                        Planning Your Next Adventure?
                    </Title>
                    <Text className="destinations-header-subtitle">
                        Discover eSIM packages for 200+ destinations worldwide
                    </Text>

                    {/* Search Bar */}
                    <div className="destinations-search-container">
                        <Search
                            placeholder="Where are you traveling?"
                            size="large"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>

                {/* Filter Buttons - Hide when searching */}
                {!searchTerm && (
                    <div className="filter-section">
                        <Card className="filter-card">
                            <Row span={24}>
                                <Col span={16}>
                                    <Text strong className="filter-label">
                                        Browse by Letter:
                                    </Text>
                                    {Object.keys(letterGroups).map((group) => (
                                        <Button
                                            key={group}
                                            size="large"
                                            className={`filter-button ${
                                                selectedGroup === group
                                                    ? 'filter-button-active'
                                                    : 'filter-button-inactive'
                                            }`}
                                            onClick={() => setSelectedGroup(group)}
                                        >
                                            {group}
                                        </Button>
                                    ))}
                                </Col>
                                <Col span={8}>
                                    <Text strong className="filter-label">
                                        <WifiOutlined /> Choose Region:
                                    </Text>
                                    <Dropdown overlay={regionsMenu} trigger={['click']}>
                                        <Button className="filter-button-active" size="large">
                                            {selectedRegion || 'Select Region'} <DownOutlined />
                                        </Button>
                                    </Dropdown>
                                </Col>
                            </Row>





                        </Card>
                    </div>
                )}

                {/* Results count */}
                <div className='results-count'>
                    <Text>
                        {searchTerm
                          ? `Found ${filteredDestinations.length} destinations for "${searchTerm}"`
                          : `Showing ${filteredDestinations.length} destinations in ${selectedGroup}`
                        }
                    </Text>
                </div>


                <Row gutter={[20, 20]}>
                    {filteredDestinations.map((item) => {
                        return (
                          <Col key={item.name} xs={24} sm={12} md={8} lg={6} xl={4}>
                              <Card
                                hoverable
                                className='destination-card'
                                bodyStyle={{ padding: 0, height: '100%', display: 'flex', flexDirection: 'column' }}
                                onClick={() => handleSeePlans(item.country_id)}
                              >

                                  <div className='destination-image-container'>
                                      <img
                                        src={`https://www.amigosim.com/assets/DestinationListingImages/${item.country_id}.webp`}
                                        alt={item.name}
                                        className='destination-image'
                                        onError={(e) => handleImageError(e, item.name)}
                                      />

                                      {/* Flag overlay */}
                                      <div className='destination-flag-overlay'>
                                          <img
                                            src={`https://flagcdn.com/32x24/${item.country_id.toLowerCase()}.png`}
                                            alt={`${item.name} flag`}
                                            className='destination-flag'
                                            onError={(e) => e.target.style.display = 'none'}
                                          />
                                      </div>
                                  </div>

                                  {/* Content */}
                                  <div className='destination-card-content'>
                                    <Title level={5} className='destination-title'>
                                      {item.name}
                                    </Title>
                                    {/*<div>
                                          <Title level={5} className="destination-title">
                                              {item.name}
                                          </Title>
                                          <div className="destination-info">
                                              <Text className="destination-price">
                                                  From ${item.price || "5"}
                                              </Text>
                                              <div className="destination-popular-badge">
                                                  Popular
                                              </div>
                                          </div>
                                      </div>*/}
                                      <a className='btn btn-primary-dark roundNew btn-block lg'>
                                          See Plans
                                      </a>
                                  </div>
                              </Card>
                          </Col>
                        )
                    })}
                </Row>

                {/* No results */}
                {filteredDestinations.length === 0 && (
                  <div>
                    {/*    <Text className="no-results-text">
                            No destinations found. Try adjusting your search.
                        </Text>*/}
                    {_.times(10, () => {
                      return (
                        <div>
                          <Skeleton paragraph={{ rows: 4 }} />
                          <br />
                        </div>
                      )
                    })}
                  </div>
                )}
            </div>
        </div>
    );
};

export default AllDestinationsPage;
